// @flow
import React, {Component} from 'react';
import type {Node} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {Link} from 'react-router-dom';
import Page from '../../containers/page/page';
import {register} from '../../redux/actions/register-actions';
import defaultStyle from '../../styles/default.module.css';
import formStyle from '../../styles/form.module.css';
import translate from '../../config/text';
import type {TranslateType} from '../../types';
import countryJson from '../../utility/countries.json';
import {Loading} from '../';
import styles from "../Login/Login.module.css";
import logo from "../../assets/CA_anniversary_logo.svg";
import Autocomplete from "./Autocomplete";




type PropsType = {
    registrationError: string,
    attemptToRegister: ({
                            email: string,
                            pass: string,
                        }) => void,
    isLoggingIn: string,
    isLoggedIn: true,
    location: {
        state: {
            from: {
                pathname: string,
            },
        },
    },
    language: string,
};

type StateType = {
    email: string,
    pass: string,
    firstName: string,
    lastName: string,
    company: string,
    sug: array,
    date: string,
    country: string,
};

type KeysType = 'email' | 'pass' | 'firstName'
    | 'lastName' | 'company' | 'retailers' | 'distributors' | 'date' | 'country';

class Register extends Component<PropsType, StateType> {
    t: TranslateType
    constructor(props: PropsType) {
        super(props);
        this.state = {
            data: null,
            isVisible: null,
            distributors: [],
            retailers: [],
            email: '',
            pass: '',
            firstName: '',
            lastName: '',
            company: '',
            date: Math.round((new Date()).getTime() / 1000),
            country: '',
        };
        this.updateText1 = this.updateText1;
        this.t = translate(this.props.language);
    }

    handleInput = (type: KeysType, value: string) => {

        this.setState(
            {[type]: value},
            function () {
                this.setDistributors();
                if(this.state.country !== ''){
                    this.setState({isVisible: true})
                }else{
                    this.setState({isVisible: false})
                }
            });


    }

    handleSubmit = (event: Event) => {
        event.preventDefault();
        this.props.attemptToRegister({
            email: this.state.email,
            pass: this.state.pass,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            country: this.state.country,
            company: this.state.company,
            date: this.state.date,
        });
    };

    setDistributors = () => {
        // if (this.state.data[this.state.country] !== undefined) {
        //
        //         let distributors = [];
        //
        //     for (let i = 0; i < this.state.data[this.state.country].length; i++){
        //         distributors.push(this.state.data[this.state.country][i]);
        //     }
        //
        //     this.setState({distributors: distributors});
        // }
        let distributors = [];
        this.setState({distributors: distributors});
    };

    componentDidMount() {
        fetch('https://www.cambridgeaudio.com/gbr/en/api/learning/autocomplete/simplified')
            .then( (response) => {
                return response.json() })
            .then( (json) => {
                this.setState({data: json});

                this.setDistributors();
            });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
    };


    updateText1 = (company) => {this.setState({ company })};


    render(): Node {
        const {from} = this.props.location.state
        || {from: {pathname: `/dashboard`}};
        if (this.props.isLoggedIn) {
            return <Redirect to={from} />;
        }

        return (
            <Page>
                <div className={defaultStyle.content}>
                    <div className={styles.logo}>
                        <img src={logo} alt={`Cambridge audio `} />
                        <div className={styles.logoTitle}>
                            {this.t('title')}
                        </div>
                    </div>

                    <h1 className={styles.formHeader}>{this.t('register')}</h1>

                    <RegistrationForm
                        handleSubmit={this.handleSubmit}
                        handleInput={this.handleInput}
                        updateText1={this.updateText1}
                        state={this.state}
                        errors={this.props.registrationError}
                        t={this.t} />
                    {
                        this.props.isLoggingIn
                            ? <Loading text={this.t('registering')} />
                            : ''
                    }
                    <div className={styles.bottom}></div>
                </div>
            </Page >
        );
    }
}

type RegistrationFormType = {
    handleSubmit: (Event) => void,
    handleInput: (KeysType, string) => void,
    state: StateType,
    errors: string,
    t: TranslateType,
};

const RegistrationForm = ({
                              handleSubmit,
                              handleInput,
                              updateText1,
                              updateText2,
                              state,
                              data,
                              errors,
                              t,
                          }: RegistrationFormType): Node => (
    <form className={`
              ${styles.form}
              ${styles.logInForm}
            `} onSubmit={handleSubmit}>
        {
            errors &&
            <div className={formStyle.errors}>
                {errors}
            </div>
        }
        <InputWithLabel
            label={t('email')}
            inputType={'email'}
            value={state.email}
            type={'email'}
            placeholder={''}
            handleInput={handleInput} />
        <InputWithLabel
            label={t('firstName')}
            inputType={'firstName'}
            value={state.firstName}
            type={'text'}
            placeholder={''}
            handleInput={handleInput} />
        <InputWithLabel
            label={t('lastName')}
            inputType={'lastName'}
            value={state.lastName}
            type={'text'}
            placeholder={''}
            handleInput={handleInput} />
        <SelectWithLabel
            label={t('country')}
            inputType={'country'}
            value={state.country}
            type={'select'}
            placeholder={''}
            handleInput={handleInput} />
        {
            state.isVisible ?
                <Autocomplete
                    updateTextCB={updateText1}
                    className={styles.left}
                    label={t('company')}
                    suggestions={state.distributors}
                    type={'text'}
                    inputType={'company'}
                    handleInput={handleInput} />
            :
            null
        }
        <div className={'dateHidden'}>
            <InputWithLabel
                label={t('date')}
                inputType={'date'}
                value={state.date}
                type={'text'}
                placeholder={''}
                handleInput={handleInput} />
        </div>
        <InputWithLabel
            label={t('password')}
            inputType={'pass'}
            value={state.pass}
            type={'password'}
            placeholder={''}
            handleInput={handleInput} />
        <div className={formStyle.checkbox}>
            <input required type="checkbox" id="tsncs" />
            <label className={formStyle.greyContent} htmlFor="tsncs">
                {t('confirmTsAndCs')}. <a href={
                `https://www.cambridgeaudio.com/legal/terms-and-conditions`
            } target="_blank">View Ts & Cs</a> & <a href={
                `https://www.cambridgeaudio.com/privacy-policy`
            } target="_blank">Cookie Policy</a>
            </label><br/>
        </div>
        <div className={`${styles.ctaContainer}`}>
            <input className={formStyle.buttonBcg} type="submit" value={t('register')} />
            <Link className={formStyle.buttonBcg} to="/login">
                {t('cancel')}
            </Link>
        </div>
    </form>
);

type LabelFormsType = {
    label: string,
    inputType: KeysType,
    value: string,
    type: string,
    placeholder: string,
    handleInput: (KeysType, string) => void,
    props?: any,
};

const InputWithLabel = ({
                            label,
                            inputType,
                            value,
                            type,
                            placeholder,
                            handleInput,
                            ...props
                        }: LabelFormsType): Node => (
    <label className={`
              ${formStyle.label}
              ${styles.label}
            `}>
        <div className={formStyle.heading}>
        </div>
        <input
            onInput={(e: Event): void =>// $FlowFixMe
                handleInput(inputType, e.target.value)
            }
            className={formStyle.input}
            value={value}
            type={type}
            placeholder={label + '*'}
            required />
    </label>
);

const SelectWithLabel = ({
                             label,
                             inputType,
                             value,
                             type,
                             placeholder,
                             handleInput,
                             ...props
                         }: LabelFormsType): Node => (
    <label className={`
              ${formStyle.label}
              ${styles.label}
            `}>
        <div className={formStyle.heading}>
        </div>
        <select
            onChange={(e: Event): void =>// $FlowFixMe
                handleInput(inputType, e.target.value)
            }
            className={formStyle.select}
            required
        >
            {
                Object.keys(countryJson).map((iso: string): Node => (
                    <option
                        key={iso}
                        value={iso}
                    >
                        {countryJson[iso]}
                    </option>
                ))
            }
        </select>
    </label>
);

type LoginDataType = {
    email: string,
    pass: string,
    firstName: string,
    lastName: string,
    country: string,
    company: string,
    date: string,
};

const mapStateToProps = (state: {status: ?{}}): ?{} => state.status;

const mapDispatchToProps = (
    dispatch: (register: () => void) => void
): {attemptToRegister: any} => ({
    attemptToRegister: (
        registerParams: LoginDataType
    ): void => dispatch(register(registerParams)),
});

const RegisterContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Register);

export default RegisterContainer;



// WEBPACK FOOTER //
// ./src/components/Register/Register.js